import * as React from "react";
import "../masterTableTab/MasterTableTab.css";
import "../capacityRoadMap/capacityRoadMap.css";
import TableComponent from "../../components/tableComponent/roadMapTableComponent/capacityRoadMapTable";
import axios from "axios";
import baseConfig from "../../../config/config";
import AddRegion from "../addRegion/addRegion";
import RemoveRegion from "../removeRegion/removeRegion"; 
import { useNavigate } from "react-router-dom";
import EditGpu from '../editGpu/editGpu'
import { useDispatch, useSelector } from "react-redux";
import { fetchGPUData } from '../../../redux/actions/actions';
import UploadExcel from "../uploadExcel/uploadExcel";

function CapacityRoadMap(props) {
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState({});
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [editHeader, setEditHeader] = React.useState('');
  const [modifiedModelTypeData, setModifiedModelTypeData] = React.useState([])
  const isGPUDataLoading = useSelector(store => store.GPUData.isGPUDataLoading);
  const isGPUDataLoaded = useSelector(store => store.GPUData.isGPUDataLoaded);
  const GPUDataError = useSelector(store => store.GPUData.GPUDataError);
  const GPUData = useSelector(store => store.GPUData.GPUData !== undefined ? store.GPUData.GPUData : []);
  const [type, setType] = React.useState('')
  const [openUploadPopup, setOpenUploadPopup] = React.useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleModal = () => {
    props.openPopup()
    setIsModalOpen(false)
    if (props.isOpen === true) {
      setSelectedData('')
    }
  };

  const handleRemoveRegionModal = () => {
    props.openRegionPopup()
    setIsModalOpen(false)
    if (props.isRegionOpen === true) {
      setSelectedData('')
    }
  };

  const handleGPUModal = (type, header) => {
    setEditHeader(header);
    props.openGpu();
    setType(type);
    setIsModalOpen(false);
    if (props.openGPU === true) {
      setSelectedData('');
    }
  };
  React.useEffect(() => {
    if (GPUDataError ) {
      navigate("/errorPage");
    }
  }, [  GPUDataError])




  React.useEffect(() => {
    if (!isGPUDataLoaded) {
      dispatch(fetchGPUData());
    }
  }, [isGPUDataLoading])

  const hasGPUData = Object.keys(GPUData).length > 0;

  React.useEffect(() => {
    setLoader(false);
  }, []);

  const getSelectedRow = (data) => {
    setSelectedData(data)
  }
  const getSelectedRowDelete = (data) => {
    setIsModalOpen(true)
  }
  const handleConfirmDelete = async () => {
    const postData = { Id: selectedData.Id };
    try {
      let csrfToken=localStorage.getItem("csrfToken")
      const response = await axios.post(
        baseConfig.apiBaseUrl + '/CapacityRoadMap/Delete',
        postData,
        {
          headers: {
            'Content-Type': 'application/json',
            "serviceid": sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        window.location.reload();
      }


    } catch (error) {
      console.error('API Error:', error);
      if (error.response.status === 401) {
        navigate("/errorPage");
      }
    }

    setIsModalOpen(false);
  };

  const handleCancelDelete = () => {
    setIsModalOpen(false);
  };
  const title = (data) => {
    if (data.length === 0) {
      return {
        fontWeight: "500",
        display: 'none'
      }
    } else {
      return { fontWeight: "500", width: "50%" }
    }
  };

  const closeUploadPopUpOpen = () => {
    setOpenUploadPopup(false)
  }
  return (
    <>
      {(!isGPUDataLoading && hasGPUData) ? (
        <>
          {Object.keys(GPUData).map((gpuType, index) => {
            const totalAllocated = GPUData[gpuType].reduce((sum, row) => sum + row.GPUsAllocated, 0);
            const totalAvailable = GPUData[gpuType].reduce((sum, row) => sum + row.GPUsAvailable, 0);
            const totalEarmarked = GPUData[gpuType].reduce((sum, row) => sum + row.GPUsEarmarked, 0);
            const totalRow = {
              Region: "Total",
              GPUsAllocated: totalAllocated,
              GPUsAvailable: totalAvailable,
              GPUsEarmarked: totalEarmarked,
            };
            const updatedTableData = [...GPUData[gpuType], totalRow];
            return (
              <div key={index} className="gpu-table-container">
                <div style={title(GPUData[gpuType])}>
                  {gpuType} GPU{" "}
                  <i
                    onClick={() => props.exportToExcel(gpuType, index)}
                    className="fas fa-file-excel"
                    style={{ color: "#216f44", cursor: "pointer" }}
                  ></i>
                </div>
                <div
                  className="boxShadow"
                  style={{ display: updatedTableData.length > 0 ? "block" : "none", marginBottom: "20px" }}
                >
                  <TableComponent
                    tableData={updatedTableData}
                    getSelectedRow={getSelectedRow}
                    handleModal={(type, header) => handleGPUModal(type, header)}
                    deleteModal={getSelectedRowDelete}
                    header={gpuType}
                    type="gpu"
                  ></TableComponent>
                </div>
              </div>
            );
          })}


          {props.isOpen && (
            <div className="modal-backdrop" ></div>
          )}

          {props.isRegionOpen && (
            <div className="modal-backdrop"></div>
          )}

          {props.openGPU && (
            <div className="modal-backdrop"></div>
          )}
          {props.isOpen ? (
            <AddRegion
              handleModal={handleModal}
              data={selectedData}
              table={modifiedModelTypeData.slice(-1)[0]?.data}
              selectedIndex={selectedIndex}
            ></AddRegion>
          ) : (
            ""
          )}

          {props.isRegionOpen ? (
            <RemoveRegion
              handleModal={handleRemoveRegionModal}
              data={selectedData}
              GPUData={GPUData}
              selectedIndex={selectedIndex}
            ></RemoveRegion>
          ) : (
            ""
          )}

          {props.openGPU ? (
            <EditGpu
              handleModal={handleGPUModal}
              data={selectedData}
              selectedIndex={selectedIndex}
              type={type}
              header={editHeader}
            ></EditGpu>
          ) : (
            ""
          )}
          {isModalOpen ? (
            <div className="modal-container" style={{ width: "45vh" }}>
              <div style={{ maxHeight: "30vh" }}>
                <p>Are you sure you want to delete this Request?</p>
                <div className="buttons-container marginBottom">
                  <button
                    className="button button-go-back"
                    onClick={handleCancelDelete}
                  >
                    Cancel
                  </button>
                  <button
                    className="button button-confirm"
                    onClick={handleConfirmDelete}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <div className="loader-container" style={{ height: "80vh" }}>
          <div className="loader"></div>
        </div>
      )}

      {openUploadPopup && (
        <>
          <UploadExcel
            closeUploadPopUpOpen={closeUploadPopUpOpen}
            isGpuAvailaibleCapacity={true}
          ></UploadExcel>
          <div className="modal-backdrop"></div>
        </>
      )}
    </>
  );
}
export default CapacityRoadMap;